<template>
    <div class="vue-calendar-filter">
        <div class="inner">
            <template v-if="isLoading">
                <span class="is-loading"><i class="icon icon-fallback-icon"></i> {{ loadingText }}</span>
            </template>

            <button class="btn btn-secondary" @click="handleClickToday">Vandaag</button>

            <button class="btn btn-secondary" @click="handleGetNextWeekend">Aankomend weekend</button>

            <date-picker v-model="pickedDate" type="date" range :placeholder="placeHolder" :disabled-date="disabledDates"></date-picker>

        </div>
        <p class="helper-text">Selecteer een van- en tot-datum.</p>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/nl';

export default {
    name: "CalendarFilter",

    props: ['placeHolder', 'currentUrl', 'loadingText'],

    components: { DatePicker },

    data() {
        return {
            pickedDate: [],
            urlParams: [],
            isLoading: false,
            isRendering: true
        }
    },

    mounted() {
        const urlParams = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        if(!_.isEmpty(urlParams.startDate) && !_.isEmpty(urlParams.endDate)) {
            this.pickedDate = [new Date(urlParams.startDate * 1000), new Date(urlParams.endDate * 1000)];
        }

        setTimeout(() => this.isRendering = false, 500);
    },

    methods: {
        handleClickToday() {
            this.pickedDate = [new Date(), new Date()];
        },

        handleGetNextWeekend() {
            this.pickedDate = [this.getNextFriday(), this.getNextSunday()];
        },

        getNextFriday() {
            const date = new Date();

            return this.resetDate( new Date(date.setDate(date.getDate() - (date.getDay() - 1) + 4)) );
        },

        getNextSunday() {
            const date = new Date();

            return this.resetDate( new Date(date.setDate(date.getDate() - (date.getDay() - 1) + 6)) );
        },

        resetDate(date) {
          date.setHours(0);
          date.setMinutes(0);
          date.setSeconds(0);
          date.setMilliseconds(0);

          console.log(date);
          console.log((date.getTime() / 1000));

          return date;
        },

        disabledDates(date) {
            return date < (new Date()).setHours(0, 0, 0, 0);
        }
    },

    watch: {
        pickedDate: _.debounce(function(date) {
            if(this.isRendering) {
                return;
            }

            this.isLoading = true;

            if(_.isNil(date[0]) || _.isNil(date[1])) {
                window.location.href = this.currentUrl;
                return;
            }

            const startDate = Math.floor(date[0].getTime() / 1000);
            const endDate = Math.floor(date[1].getTime() / 1000);

            let url = this.currentUrl + `?startDate=${startDate}&endDate=${endDate}`;

            let params = new URLSearchParams(window.location.search);

            for(var pair of params.entries()) {
                if(pair[0] !== 'startDate' && pair[0] !== 'endDate') {
                    url += `&` + pair[0] + `=` + pair[1];
                }
            }

            window.location.href = url;
        }, 200)
    }
}
</script>
